/* Fransk katalog for locale-no.js (del 4 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Réduction possible du délai de crédit',
  'adv.sales.move.chaseSlowPayers.effectNote': 'jusqu\'à votre propre moyenne — l\'effet en couronnes dépend du moment où le client paie réellement',
  'adv.sales.move.chaseSlowPayers.action': 'Voir la liste des factures',
  'adv.sales.move.reviewDiscounts.title': 'Passer en revue les remises',
  'adv.sales.move.reviewDiscounts.text': 'Vous avez accordé {amount} de remises cette année, en moyenne {pct} % par facture.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Effet estimé',
  'adv.sales.move.reviewDiscounts.effectNote': 'en divisant le niveau de remise par deux',
  'adv.sales.move.reviewDiscounts.action': 'Voir la liste des factures',
  'adv.sales.move.spreadCustomers.title': 'Diversifier la clientèle',
  'adv.sales.move.spreadCustomers.text': '{name} représente {pct} % des ventes. Un seul client ne devrait pas porter à lui seul le chiffre d\'affaires.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Part du plus gros client',
  'adv.sales.move.spreadCustomers.effectNote': 'c\'est le risque, pas un gain',
  'adv.sales.move.spreadCustomers.action': 'Voir les clients',
  'adv.sales.move.testPriceIncrease.title': 'Envisager une hausse des prix',
  'adv.sales.move.testPriceIncrease.text': 'Testez l\'effet d\'un prix supérieur de {pct} % sur le chiffre d\'affaires avant de décider.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Effet annuel estimé',
  'adv.sales.move.testPriceIncrease.effectNote': 'à volume constant',
  'adv.sales.move.testPriceIncrease.action': 'Voir les produits',
  'adv.sales.move.growRecurring.title': 'Développer les ventes récurrentes',
  'adv.sales.move.growRecurring.text': '{pct} % des ventes sont récurrentes. En vous rapprochant de {target} %, le chiffre d\'affaires devient bien plus prévisible.',
  'adv.sales.move.growRecurring.effectLbl': 'Chiffre d\'affaires pouvant devenir prévisible',
  'adv.sales.move.growRecurring.effectNote': 'si la part atteint l\'objectif',
  'adv.sales.move.growRecurring.action': 'Voir les abonnements',
  'adv.sales.scn.title': 'Scénarios de vente — Que se passe-t-il si …',
  'adv.sales.scn.sub': 'Effet sur le chiffre d\'affaires, le résultat et la trésorerie',
  'adv.sales.scn.help': 'Choisissez un scénario pour voir l\'avant/après sur le chiffre d\'affaires, le résultat, la marge et la trésorerie, avec les hypothèses que j\'ai retenues. Les chiffres sont des calculs, pas des garanties.',
  'adv.sales.scn.metric': 'Indicateur',
  'adv.sales.scn.base': 'Base',
  'adv.sales.scn.after': 'Après scénario',
  'adv.sales.scn.change': 'Variation',
  'adv.sales.scn.row.revenue': 'Chiffre d\'affaires',
  'adv.sales.scn.row.result': 'Résultat',
  'adv.sales.scn.row.margin': 'Marge nette',
  'adv.sales.scn.row.liquidity': 'Solde prévisionnel calculé',
  'adv.sales.scn.points': '{points} pts',
  'adv.sales.scn.assumptions': 'Hypothèses',
  'adv.sales.scn.showAssumptions': 'Afficher les hypothèses',
  'adv.sales.scn.confidence': 'Fiabilité',
  'adv.sales.scn.risk': 'Risque',
  'adv.sales.scn.scope': 'Portée',
  'adv.sales.scn.q.priceUp': 'J\'augmente les prix',
  'adv.sales.scn.q.volumeDown': 'Le volume des ventes baisse',
  'adv.sales.scn.q.halveDiscounts': 'Je supprime la moitié des remises',
  'adv.sales.scn.q.loseTopCustomer': 'Je perds {name}',
  'adv.sales.scn.q.growRecurring': 'Les ventes récurrentes augmentent de {pct} %',
  'adv.sales.scn.summary.priceUp': 'À volume constant, une hausse des prix de {pct} % rapporte environ {delta} de chiffre d\'affaires annuel en plus. Une hausse des prix n\'ajoute aucun coût de marchandises ou d\'heures, donc la totalité du montant se répercute sur le résultat.',
  'adv.sales.scn.summary.volumeDown': 'Une baisse de volume de {pct} % retire environ {delta} du chiffre d\'affaires. Le calcul suppose que les charges restent stables : c\'est donc le scénario le plus sévère — si les achats baissent avec le volume, l\'impact est moindre.',
  'adv.sales.scn.summary.halveDiscounts': 'Vous avez accordé {amount} de remises cette année, en moyenne {pct} %. En divisant ce niveau par deux, vous récupérez environ {delta} — à condition que les clients restent.',
  'adv.sales.scn.summary.loseTopCustomer': 'Si {name} part, vous perdez {delta} — {pct} % des ventes. C\'est ce chiffre qui justifie de diversifier la clientèle avant que cela n\'arrive.',
  'adv.sales.scn.summary.growRecurring': 'Si les ventes récurrentes augmentent de {pct} %, cela rapporte environ {delta} de plus par an. Les revenus récurrents sont le chiffre d\'affaires le plus prévisible dont vous disposez.',
  'adv.sales.scn.assumption.priceUp': 'Le volume se maintient. S\'applique à tous les produits et services.',
  'adv.sales.scn.assumption.volumeDown': 'Les charges restent stables. Plumme n\'a pas de prix de revient par produit, je ne peux donc pas calculer quelle part des charges baisse avec le volume.',
  'adv.sales.scn.assumption.halveDiscounts': 'Les clients achètent autant avec une remise plus faible. Calculé à partir des remises réellement accordées cette année.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Aucune part du chiffre d\'affaires n\'est remplacée par d\'autres clients. Calculé à partir des ventes réellement comptabilisées du client.',
  'adv.sales.scn.assumption.growRecurring': 'La croissance s\'ajoute aux ventes actuelles, elle ne les remplace pas.',
  'adv.sales.scn.riskText.priceUp': 'Si le volume baisse plus que la hausse de prix, l\'effet disparaît. Surveillez le volume des ventes pendant les deux premiers mois.',
  'adv.sales.scn.riskText.volumeDown': 'Si le volume baisse d\'abord chez les clients les plus rentables, l\'impact sera plus important que cela.',
  'adv.sales.scn.riskText.halveDiscounts': 'Les clients qui achètent grâce à la remise peuvent partir. Testez d\'abord auprès de quelques-uns.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Les coûts fixes ne disparaissent pas avec le client : le résultat est donc plus touché que le chiffre d\'affaires.',
  'adv.sales.scn.riskText.growRecurring': 'Les contrats récurrents vous engagent sur le prix et la livraison dans la durée.',
  'adv.sales.scn.scopeText.all': 'Tous les produits et services',
  'adv.sales.scn.scopeText.discounted': 'Uniquement les factures avec remise',
  'adv.sales.scn.scopeText.topCustomer': 'Uniquement le plus gros client',
  'adv.sales.scn.scopeText.recurring': 'Uniquement les ventes récurrentes',
  'adv.sales.closerTag': 'Voici ce que je ferais',
  'adv.tab.tax': 'Impôts',
  'adv.tab.budget': 'Budget',
  'adv.tab.insight': 'Analyses',
  'adv.plan.title': 'Budget vs réel',
  'adv.plan.sub': '{year} — comptabilisé à ce jour par rapport au budget des {months} premiers mois',
  'adv.plan.help': 'Les chiffres comptabilisés portent sur l\'année en cours, tandis que le budget couvre toute l\'année. Je compare donc avec le budget jusqu\'au mois en cours inclus — sinon tout semblerait très en dessous du budget en janvier.',
  'adv.plan.tableTitle': 'Écart par catégorie',
  'adv.plan.tableSub': 'Budget des {months} premiers mois par rapport au comptabilisé',
  'adv.plan.tableHelp': 'Les lignes sont triées par ampleur de l\'écart. Les comptes mouvementés mais non budgétés sont aussi affichés — ce sont souvent les plus intéressants.',
  'adv.plan.col.category': 'Catégorie',
  'adv.plan.col.budget': 'Budget à ce jour',
  'adv.plan.col.actual': 'Comptabilisé',
  'adv.plan.col.variance': 'Écart',
  'adv.plan.unbudgeted': 'Non budgété',
  'adv.plan.incomeVariance': 'Écart de produits',
  'adv.plan.costVariance': 'Écart de charges',
  'adv.plan.abovePlan': 'au-dessus du plan',
  'adv.plan.belowPlan': 'en dessous du plan',
  'adv.plan.overPlan': 'au-dessus du plan',
  'adv.plan.underPlan': 'en dessous du plan',
  'adv.plan.separateNote': 'Les écarts de produits et de charges sont affichés séparément. Combinés, un manque à gagner sur les produits et une économie sur les charges pourraient s\'annuler et donner l\'impression que tout se déroule comme prévu.',
  'adv.plan.noteWorse': '{name} s\'écarte de {amount} dans le mauvais sens après {months} mois. À examiner avant que l\'écart ne se creuse sur le reste de l\'année.',
  'adv.plan.noteBetter': '{name} est {amount} au-dessus du budget après {months} mois.',
  'adv.plan.noteUnbudgeted': '{amount} ont été comptabilisés sur {name} sans que le compte soit budgété.',
  'adv.plan.editBudget': 'Modifier le budget',
  'adv.plan.noBudgetTitle': 'Aucun budget pour cette année',
  'adv.plan.noBudgetText': 'Sans budget, je n\'ai rien à quoi comparer les chiffres comptabilisés. Si vous en créez un, j\'affiche les écarts par catégorie et je vous alerte quand quelque chose s\'éloigne du plan.',
  'adv.plan.goToBudget': 'Créer un budget',
  'adv.plan.notStartedTitle': 'L\'année n\'a pas encore commencé',
  'adv.plan.notStartedText': 'Il n\'y a aucun mois comptabilisé en {year} à comparer au budget.',
  'adv.plan.goalsTitle': 'Objectifs',
  'adv.plan.goalsSub': 'Vos propres objectifs, mesurés par rapport aux chiffres comptabilisés',
  'adv.plan.goalsHelp': 'L\'objectif s\'affiche à partir de l\'année pour laquelle vous le créez, jusqu\'à ce que vous le marquiez comme terminé. Un objectif dont l\'échéance est dépassée reste visible jusqu\'à ce que vous le réévaluiez. Le chiffre d\'affaires, le résultat et la marge sont mesurés par exercice, tandis que la réserve suit le solde.',
  'adv.plan.goalsEmptyTitle': 'Aucun objectif défini',
  'adv.plan.goalsEmptyText': 'Fixez un objectif avec une échéance — par exemple une réserve de trésorerie ou une marge bénéficiaire — et je suivrai la progression en vous prévenant si vous prenez du retard.',
  'adv.plan.goalNew': 'Nouvel objectif',
  'adv.plan.goalEdit': 'Modifier l\'objectif',
  'adv.plan.goalSave': 'Enregistrer l\'objectif',
  'adv.plan.goalSaved': 'Objectif enregistré',
  'adv.plan.goalSaveFailed': 'Impossible d\'enregistrer l\'objectif',
  'adv.plan.goalDeleted': 'Objectif supprimé',
  'adv.plan.goalTitleLabel': 'Quel est l\'objectif ?',
  'adv.plan.goalTitlePh': 'Ex. Constituer une réserve de trésorerie avant la fin de l\'année',
  'adv.plan.goalMetricLabel': 'Que faut-il mesurer ?',
  'adv.plan.goalMetricHint': 'La valeur actuelle provient de la comptabilité, et non de ce que vous saisissez.',
  'adv.plan.goalTargetAmount': 'Valeur cible (kr)',
  'adv.plan.goalTargetPct': 'Valeur cible (%)',
  'adv.plan.goalNow': 'Actuel',
  'adv.plan.goalTarget': 'Objectif',
  'adv.plan.goalDeadline': 'Échéance',
  'adv.plan.goalDaysLeft': 'Jours restants',
  'adv.plan.goalMeasured': 'Mesuré par rapport à : {metric}',
  'adv.plan.goalFromYear': 'À partir de {year}',
  'adv.plan.goalReached': 'Atteint',
  'adv.plan.goalCompleted': 'Terminé',
  'adv.plan.goalNeedsReview': 'Échéance dépassée – réévaluez l\'objectif',
  'adv.plan.goalComplete': 'Marquer l\'objectif comme terminé',
  'adv.plan.goalReopen': 'Rouvrir l\'objectif',
  'adv.plan.goalOverdue': 'L\'échéance est dépassée',
  'adv.plan.goalOnTrack': 'Dans les temps',
  'adv.plan.goalBehind': 'En retard sur le plan',
  'adv.plan.goalTracking': 'En suivi',
  'adv.plan.metric.buffer': 'Trésorerie en fin d\'année',
  'adv.plan.metric.income': 'Chiffre d\'affaires comptabilisé',
  'adv.plan.metric.result': 'Résultat comptabilisé',
  'adv.plan.metric.margin': 'Marge bénéficiaire',
  'adv.plan.saving': 'Enregistrement …',
  'adv.plan.eventsTitle': 'Événements prévus',
  'adv.plan.eventsSub': 'Encaissements et décaissements connus non encore comptabilisés',
  'adv.plan.eventsHelp': 'Les événements s\'affichent dans l\'année de leur date. Ils ne sont pas reportés automatiquement à l\'année suivante ; modifiez la date si le paiement est reporté. Seuls les événements à venir et non comptabilisés sont intégrés à la prévision de trésorerie.',
  'adv.plan.eventsEmptyTitle': 'Aucun événement prévu',
  'adv.plan.eventsEmptyText': 'Sans événements enregistrés, la courbe de trésorerie reste plate après le mois en cours, car elle ne connaît que les chiffres comptabilisés.',
  'adv.plan.eventsNote': 'Les événements des mois précédents ne sont pas pris en compte dans la courbe. Supprimez un événement une fois le paiement comptabilisé, afin qu\'il ne soit pas compté deux fois.',
  'adv.plan.eventNew': 'Nouvel événement',
  'adv.plan.eventEdit': 'Modifier l\'événement',
  'adv.plan.eventSave': 'Enregistrer l\'événement',
  'adv.plan.eventSaved': 'Événement enregistré',
  'adv.plan.eventSaveFailed': 'Impossible d\'enregistrer l\'événement',
  'adv.plan.eventDeleted': 'Événement supprimé',
  'adv.plan.eventLabel': 'De quoi s\'agit-il ?',
  'adv.plan.eventLabelPh': 'Ex. Indemnités de congés payés des salariés',
  'adv.plan.eventKind': 'Type',
  'adv.plan.eventDate': 'Date',
  'adv.plan.eventDirection': 'Sens',
  'adv.plan.eventDirectionHint': 'Une sortie diminue la trésorerie, une entrée l\'augmente.',
  'adv.plan.directionOut': 'Sortie du compte',
  'adv.plan.directionIn': 'Entrée sur le compte',
  'adv.plan.eventAmount': 'Montant',
  'adv.plan.kind.salary': 'Salaires et primes',
  'adv.plan.kind.tax': 'Impôts et taxes',
  'adv.plan.kind.supplier': 'Paiement fournisseur',
  'adv.plan.kind.investment': 'Investissement',
  'adv.plan.kind.loan': 'Emprunts et remboursements',
  'adv.plan.kind.other': 'Autre',
  'adv.tab.reports': 'Rapports',
  'adv.tab.benchmark': 'Comparaison',
  'adv.basisCmp.title': 'Base de comparaison',
  'adv.basisCmp.sub': 'Ce à quoi les chiffres sont réellement comparés',
  'adv.basisCmp.help': 'Les indicateurs ci-dessous ne sont pas comparés à d\'autres entreprises. Deux sont mesurés par rapport aux propres chiffres de l\'entreprise de l\'année précédente, et deux par rapport à un seuil fixe. Chaque ligne indique de quel cas il s\'agit.',
  'adv.basisCmp.year': 'Exercice',
  'adv.basisCmp.against': 'Comparé à',
  'adv.basisCmp.againstValue': 'Propres chiffres de {year}',
  'adv.basisCmp.source': 'Source des données',
  'adv.basisCmp.sourceValue': 'Chiffres comptabilisés dans Plumme',
  'adv.basisCmp.industry': 'Données sectorielles',
  'adv.basisCmp.industryValue': 'Non disponibles',
  'adv.basisCmp.row.previousYear': 'vs {year}',
  'adv.basisCmp.row.threshold': 'vs seuil fixe',
  'adv.hero.tag': 'L\'analyse de SuperPlumma ce mois-ci',
  'adv.hero.empty': 'AI Conseiller a besoin de produits, de charges et de postes ouverts comptabilisés avant de pouvoir donner des conseils concrets.',
  'adv.hero.freeCapital': 'Capital disponible',
  'adv.hero.notCalculated': 'non calculé',
  'adv.hero.healthScore': 'Score de santé',
  'adv.hero.waiting': 'en attente',
  'adv.hero.ask': 'Demander à SuperPlumma',
  'adv.hero.chatTitle': 'Discuter avec SuperPlumma',
  'adv.hero.chatHint': 'Discutez avec moi',
  'adv.hero.briefTag': 'Analyse mensuelle de SuperPlumma · {year}',
  'adv.hero.healthLead': 'Santé financière :',
  'adv.hero.greeting.morning': 'Bonjour.',
  'adv.hero.greeting.day': 'Bonjour.',
  'adv.hero.greeting.evening': 'Bonsoir.',
  'adv.hero.greetingNamed.morning': 'Bonjour, {name}.',
  'adv.hero.greetingNamed.day': 'Bonjour, {name}.',
  'adv.hero.greetingNamed.evening': 'Bonsoir, {name}.',
  'adv.hero.tasksToday': '{count} choses à faire aujourd\'hui',
  'adv.hero.seeAnalysis': 'Voir l\'analyse',
  'adv.hero.effectNote.earlierIn': 'encaissé plus tôt',
  'adv.hero.effectNote.overduePayables': 'échu envers les fournisseurs',
  'adv.hero.effectNote.vatToCover': 'à couvrir',
  'adv.hero.effectNote.vouchersAtRisk': 'achats sans justificatif',
  'adv.overnight.title': 'SuperPlumma a passé en revue',
  'adv.overnight.transactions': '{count} transactions analysées',
  'adv.overnight.vouchers': '{count} justificatifs contrôlés',
  'adv.overnight.risks': '{count} risques évalués',
  'adv.overnight.recommendations': '{count} recommandations trouvées',
  'adv.overnight.updated': 'Dernière mise à jour {time}',
  'adv.analysis.title': 'Analyse AI ouverte de la comptabilité',
  'adv.analysis.empty': 'L\'analyse n\'est pas disponible pour le moment.',
  'adv.feed.title': 'SuperPlumma a veillé',
  'adv.feed.sub': 'Ce que j\'ai remarqué récemment',
  'adv.feed.help': 'Des changements que j\'ai repérés dans la comptabilité — pas des recommandations. Le rouge est urgent, l\'orange doit être suivi, le vert est seulement informatif.',
  'adv.feed.seeDetails': 'Voir les détails',
  'adv.feed.marginDown.title': 'La marge bénéficiaire a baissé de {points} points de pourcentage',
  'adv.feed.marginDown.body': 'Par rapport à l\'année dernière. À examiner de plus près avant que cela ne devienne une tendance.',
  'adv.feed.marginUp.title': 'La marge bénéficiaire a augmenté de {points} points de pourcentage',
  'adv.feed.marginUp.body': 'Par rapport à l\'année dernière. Aucune action nécessaire — simplement bon à savoir.',
  'adv.feed.costLineJump.title': '{name} a augmenté de {pct} %',
  'adv.feed.costLineJump.body': 'Ce poste de coûts progresse plus vite que les autres par rapport à l\'année dernière.',
  'adv.feed.overdueSales.title': '{amount} de créances clients sont échues',
  'adv.feed.overdueSales.body': 'L\'argent est déjà gagné — il reste juste à l\'encaisser.',
  'adv.feed.overduePurchases.title': '{amount} de dettes fournisseurs sont échues',
  'adv.feed.overduePurchases.body': 'Des dettes fournisseurs échues peuvent entraîner des intérêts de retard et des frais de relance.',
  'adv.feed.concentration.title': 'Un client représente {pct} % des ventes',
  'adv.feed.concentration.body': 'Une forte dépendance envers un client rend le chiffre d\'affaires vulnérable si ce client part.',
  'adv.feed.costsDown.title': 'Les coûts ont baissé de {pct} % par rapport à l\'année dernière',
  'adv.feed.costsDown.body': 'Aucune action nécessaire — simplement bon à savoir.',
  'adv.feed.incomeUp.title': 'Le chiffre d\'affaires a augmenté de {pct} % par rapport à l\'année dernière',
  'adv.feed.incomeUp.body': 'La croissance est calculée à partir des produits comptabilisés sur la même période.',
  'adv.feed.vouchersComplete.title': 'Tous les achats ont un justificatif',
  'adv.feed.vouchersComplete.body': 'Rien ici ne nécessite votre attention pour le moment.',
  'adv.employees.title': 'Salariés & paie',
  'adv.employees.help': 'Ce module s\'affiche uniquement parce que l\'entreprise a des salariés ou des traitements de paie. Les chiffres proviennent des charges de personnel comptabilisées et de vos traitements de paie.',
  'adv.employees.count': 'Salariés',
  'adv.employees.share': 'Charges de personnel / chiffre d\'affaires',
  'adv.employees.cost': 'Charges de personnel comptabilisées',
  'adv.employees.runs': 'Traitements de paie cette année',
  'adv.employees.note': 'La part salariale est calculée à partir des comptes de la série 5000 comptabilisés par rapport au chiffre d\'affaires de l\'année.',
  'adv.employees.go': 'Voir la paie',
  'adv.taskcenter.title': 'Mes tâches de SuperPlumma',
  'adv.taskcenter.all': 'Toutes',
  'adv.taskcenter.empty': 'Aucune tâche dans cette catégorie.',
  'adv.status.bucket.now': 'Action requise maintenant',
  'adv.profile.title': 'Profil de conseil',
  'adv.profile.help': 'Tout ce que SuperPlumma sait sur la manière dont vous souhaitez être conseillé — réserve, objectif, niveau de risque et fréquence — réuni en un seul endroit. Vous pouvez tout modifier ici.',
  'adv.profile.intro': 'J\'utilise ces informations pour rendre mes conseils plus pertinents. Modifier quelque chose ici change ma façon de prioriser — pas la façon dont la comptabilité est tenue.',
  'adv.profile.buffer': 'Réserve souhaitée',
  'adv.profile.mainGoal': 'Objectif principal',
  'adv.profile.mainGoal.revenue': 'Augmenter le chiffre d\'affaires',
  'adv.profile.mainGoal.profitability': 'Améliorer la rentabilité',
  'adv.profile.mainGoal.buffer': 'Constituer une réserve de trésorerie',
  'adv.profile.mainGoal.hiring': 'Recruter',
  'adv.profile.mainGoal.investment': 'Investir',
  'adv.profile.mainGoal.workload': 'Réduire la charge de travail',
  'adv.profile.mainGoal.dividend': 'Préparer l\'entreprise à verser des dividendes',
  'adv.profile.risk': 'Niveau de risque préféré',
  'adv.profile.risk.cautious': 'Sûr et prudent',
  'adv.profile.risk.balanced': 'Équilibré',
  'adv.profile.risk.offensive': 'Ouvert au risque',
  'adv.profile.cadence': 'Fréquence souhaitée des conseils',
  'adv.profile.cadence.daily': 'Quotidienne',
  'adv.profile.cadence.weekly': 'Hebdomadaire',
  'adv.profile.cadence.monthly': 'Mensuelle',
  'adv.profile.accountantInvolved': 'Impliquer le comptable dans les propositions qui nécessitent une appréciation',
  'adv.profile.investments': 'Événements prévus',
  'adv.profile.noInvestments': 'Aucun enregistré',
  'adv.profile.season': 'Saisonnalité',
  'adv.profile.seasonText': 'Mois forts : {strong}. Mois faibles : {weak}.',
  'adv.profile.noSeason': 'Trop peu d\'écritures pour dégager une tendance pour le moment.',
  'adv.profile.learned': 'Ce que j\'ai appris de vos choix',
  'adv.profile.nothingLearned': 'Rien appris pour le moment.',
  'adv.profile.saveFailed': 'Impossible d\'enregistrer le profil de conseil',
  'adv.buffer.recommended': 'Réserve recommandée',
  'adv.buffer.chosen': 'Réserve choisie',
  'adv.buffer.edit': 'Ajuster la réserve de trésorerie',
  'adv.buffer.editAria': 'Ajuster la réserve de trésorerie de {amount}',
  'adv.buffer.title': 'Réserve de trésorerie',
  'adv.buffer.auto': 'Recommandation automatique',
  'adv.buffer.autoHelp': 'SuperPlumma utilise le besoin calculé le plus élevé. La recommandation actuelle est de {amount}.',
  'adv.buffer.custom': 'Montant personnalisé',
  'adv.buffer.customHelp': 'Utiliser ce montant comme seuil fixe pour les conseils, les risques et la trésorerie.',
  'adv.buffer.amount': 'Réserve souhaitée en couronnes',
  'adv.buffer.basisTitle': 'Base de la recommandation automatique',
  'adv.buffer.basisMinimum': 'Niveau minimum',
  'adv.buffer.basisMonthlyCosts': 'Un mois de charges',
  'adv.buffer.basisTax': 'Réserve fiscale calculée',
  'adv.buffer.basisVat': 'TVA à venir',
  'adv.buffer.basisHelp': 'La réserve automatique utilise le plus élevé de ces montants. C\'est un seuil de pilotage, pas de l\'argent placé sur un compte séparé.',
  'adv.buffer.saving': 'Enregistrement …',
  'adv.buffer.saved': 'Réserve de trésorerie enregistrée',
  'adv.buffer.invalid': 'Saisissez un montant supérieur à 0 kr.',
  'adv.buffer.unavailable': 'Le réglage de la réserve n\'est pas disponible pour le moment.',
  'adv.buffer.saveFailed': 'Impossible d\'enregistrer la réserve de trésorerie.',
  'adv.generated.kicker': 'Analyse AI ouverte de la comptabilité',
  'adv.generated.daily': 'Conseil du jour',
  'adv.generated.monthly': 'Ce mois-ci',
  'adv.generated.previousMonthly': 'Mois précédent',
  'adv.generated.loading': 'SuperPlumma lit les données de conseil mises à jour …',
  'adv.generated.updated': 'Mis à jour {date}',
  'adv.generated.topOpportunity': 'Votre plus grand potentiel',
  'adv.generated.changes': 'Que se passe-t-il en ce moment ?',
  'adv.generated.actions': 'Ce que je ferais maintenant',
  'adv.generated.opportunities': 'Opportunités',
  'adv.generated.taxChecks': 'Impôts et TVA – points de contrôle',
  'adv.generated.more': 'Voir plus d\'opportunités et de points de contrôle',
  'adv.generated.nextStep': 'Étape suivante',
  'adv.generated.readOnly': 'L\'analyse est uniquement consultative et n\'effectue aucune action.',
  'adv.generated.importCoverage': 'Basé sur les totaux importés et les soldes des comptes de tiers. Le contrôle des écritures individuelles et de l\'exhaustivité des justificatifs est limité.',
  'adv.generated.refresh': 'Actualiser les conseils',
  'adv.generated.failed': 'Impossible d\'actualiser le conseil AI pour le moment.',
  'adv.generated.unavailable': 'Aucun conseil AI n\'est encore prêt',
  'adv.generated.empty': 'Aucun conseil finalisé à afficher pour le moment. Essayez d\'actualiser les conseils.',
  'adv.generated.limitReached': 'La limite mensuelle de nouveaux conseils AI est atteinte. Les conseils existants restent disponibles, et la limite sera réinitialisée le mois prochain.',
  'adv.generated.todayCurrent': 'Le conseil du jour est prêt',
  'adv.generated.monthCurrent': 'Le conseil du mois a été mis à jour aujourd\'hui',
  'adv.generated.previousMonthCurrent': 'La rétrospective a été mise à jour aujourd\'hui',
  'adv.generated.noDataChanges': 'Aucune nouvelle donnée',
  'adv.generated.monthCooldown': 'Mise à jour hebdomadaire',
  'adv.generated.todayAlreadyCurrent': 'Le conseil du jour est déjà disponible. Vous recevrez un nouveau conseil du jour au plus tôt demain.',
  'adv.generated.monthAlreadyCurrent': 'Le conseil du mois a été mis à jour aujourd\'hui. Il pourra être actualisé demain si les données comptables changent.',
  'adv.generated.previousMonthAlreadyCurrent': 'La rétrospective a été mise à jour aujourd\'hui. Elle pourra être actualisée demain si de nouvelles données sont comptabilisées sur la période.',
  'adv.generated.noDataChangesInfo': 'Aucune nouvelle donnée comptable depuis le dernier conseil. Aucun appel AI n\'a été utilisé.',
  'adv.generated.monthCooldownInfo': 'Le conseil mensuel peut être mis à jour une fois par semaine lorsque la base comptable a changé.',
  'adv.generated.previousKept': 'Le conseil précédent reste affiché.',
  'adv.generated.type.booked': 'Fait comptabilisé',
  'adv.generated.type.calculated': 'Calculé',
  'adv.generated.type.scenario': 'Scénario',
  'adv.generated.type.opportunity': 'Opportunité',
  'adv.generated.type.control': 'Point de contrôle',
  'adv.generated.confidence.high': 'Base solide',
  'adv.generated.confidence.medium': 'Base moyenne',
  'adv.generated.confidence.low': 'Base limitée',
  'adv.health.title': 'Score de santé financière',
  'adv.health.sub': 'Évaluation globale de la situation financière de l\'entreprise',
  'adv.health.help': 'Un score global n\'est affiché que lorsque les quatre indicateurs peuvent être calculés. Les valeurs inconnues ne rapportent aucun point. Consultez la base de données pour voir ce qui manque.',
  'adv.health.badge.good': 'Sain',
  'adv.health.badge.stable': 'Stable',
  'adv.health.badge.weak': 'Fragile',
  'adv.health.badge.none': 'Données insuffisantes',
  'adv.health.word.good': 'Bonne santé financière',
  'adv.health.word.stable': 'Finances stables',
  'adv.health.word.weak': 'Nécessite un suivi',
  'adv.health.word.none': 'Évaluation provisoire',
  'adv.health.emptyTitle': 'Données insuffisantes pour un score de santé',
  'adv.health.emptyText': 'Comptabilisez des ventes, des achats et des éléments ouverts pour activer l\'analyse.',
  'adv.health.summaryFallback': 'SuperPlumma évalue la trésorerie, la croissance, la rentabilité et la stabilité à partir de votre comptabilité.',
  'vat.wordMva': 'TVA',
  'vat.wordMoms': 'TVA',
  'vat.exemptMva': 'Hors champ de la TVA',
  'vat.exemptMoms': 'Hors TVA',
  'vat.rateLabel': '{{rate}} % {{word}}',
  'vat.zeroRated': '0 % {{suffix}}',
  'vat.zeroRatedSuffixMva': 'exonéré',
  'vat.zeroRatedSuffixMoms': 'exonéré de TVA',
  'vat.salesReverseCharge51': '51 - Autoliquidation sur les ventes',
  'vat.export52': '52 - Exportation',
  'adv.health.category.likviditet': 'Trésorerie',
  'adv.health.category.vekst': 'Croissance',
  'adv.health.category.lonnsomhet': 'Rentabilité',
  'adv.health.category.stabilitet': 'Stabilité',
  'adv.health.note.noOpenPayables': 'Aucune dette fournisseur ouverte enregistrée',
  'adv.health.note.noDebt': 'Aucune dette',
  'adv.health.note.unknown': 'Inconnu',
  'adv.health.note.receivablesVsPayables': 'Créances clients rapportées aux dettes fournisseurs ouvertes',
  'adv.health.note.zeroPrevYearRevenue': 'Le chiffre d\'affaires de l\'an dernier est de 0 ; la croissance en pourcentage ne peut pas être calculée',
  'adv.health.note.needsPrevYear': 'Chiffres de l\'an dernier nécessaires pour la comparaison',
  'adv.health.note.revenueChangeVsPrevYear': 'Évolution du chiffre d\'affaires par rapport à la même période l\'an dernier',
  'adv.health.note.marginFromReport': 'Marge de résultat issue du compte de résultat',
  'adv.health.note.noBookedRevenue': 'Aucun chiffre d\'affaires comptabilisé pour l\'année sélectionnée',
  'adv.health.note.largestCustomerShare': 'Part des ventes réalisée avec le plus gros client',
  'adv.health.note.needsInvoicesPerCustomer': 'Ventes facturées par client nécessaires',
  'adv.help.healthCard': 'Le score de santé est un total simple de 0 à 100. Il prend en compte plusieurs éléments à la fois, comme la trésorerie, les produits, les charges et les risques. C\'est un repère, pas un verdict.',
  'adv.help.liquidity': 'Ce montant correspond aux créances clients ouvertes moins les dettes fournisseurs ouvertes. Il n\'indique pas combien d\'argent se trouve sur le compte bancaire.',
  'adv.help.expectedBalance': 'Solde prévisionnel calculé en fin de période. Les chiffres ne reposent pas sur un solde bancaire rapproché ni sur des dates de paiement certaines.',
  'adv.help.expectedIn': 'Produits comptabilisés dans la fenêtre affichée, et non des encaissements confirmés.',
  'adv.help.expectedOut': 'Charges comptabilisées dans la fenêtre affichée, et non des décaissements confirmés.',
  'adv.help.cashBalance': 'Le solde correspond à l\'argent disponible à cet instant dans ce calcul.',
  'adv.help.bookedIn': 'Les entrées comptabilisées sont les produits ou encaissements déjà enregistrés dans la comptabilité pour la période.',
  'adv.help.bookedOut': 'Les sorties comptabilisées sont les charges ou décaissements déjà enregistrés dans la comptabilité pour la période.',
  'adv.help.endBalance': 'Le solde final correspond au solde du jour plus les entrées, moins les sorties. Il montre où la trésorerie aboutit dans ce calcul.',
  'adv.help.buffer': 'La réserve de trésorerie est un seuil de sécurité souhaité. Ce n\'est pas un compte distinct, mais un montant que Plumme utilise pour vous avertir lorsque la trésorerie devient trop faible.',
  'adv.help.bufferMinimum': 'Le niveau minimum est la réserve la plus basse recommandée par Plumme. Il évite que la recommandation soit trop faible lorsque l\'entreprise a peu d\'historique.',
  'adv.help.monthlyCosts': 'Un mois de charges correspond à peu près à ce que l\'entreprise dépense habituellement en un mois. Cela vous aide à traverser un mois difficile.',
  'adv.help.taxReserve': 'La réserve fiscale est l\'argent que vous devriez mettre de côté pour les impôts, afin que la facture fiscale ne soit pas une surprise.',
  'adv.help.vatDue': 'La TVA à venir est la taxe sur la valeur ajoutée qui devrait vraisemblablement être payée à la prochaine échéance de TVA.',
});
